// Shared chatbot theme configuration for all public agents
export const chatbotThemeOptions = {
  backgroundColor: 'rgba(0, 0, 0, 0.68)',
  bubbleBackground: 'rgba(255, 255, 255, 0.08)',
  bubbleBorderColor: 'rgba(255, 255, 255, 0.12)',
  bubbleBorderRadius: 18,
  bubbleTextColor: '#ffffff',
  bubbleFromUserBackground: '#6c5ce7',
  bubbleFromUserBorderRadius: 18,
  bubbleFromUserTextColor: '#ffffff',
  markdownRespectCRLF: true,
  rootHeight: '100%',
  rootWidth: '100%',
  sendBoxBackground: 'transparent',
  sendBoxBorderTop: 'none',
  sendBoxButtonColor: '#a29bfe',
  sendBoxButtonColorOnDisabled: 'rgba(255,255,255,0.35)',
  sendBoxTextColor: '#ffffff',
  hideSendBox: false,
  sendBoxHeight: 45,
  subtle: '#b8c2d1',
  timestampColor: 'rgba(255,255,255,0.5)',
};
